<template>
  <el-dialog
    :model-value="isOpen"
    width="744px"
    @close="$emit('close')"
  >
    <h1 class="tw-mb-8">
      {{ $t('foreigners.permits.add') }}
    </h1>
    <el-form
      ref="Form"
      :model="form"
      :rules="formRules"
      label-position="top"
      :disabled="isLoading"
      class="tw-flex tw-flex-col tw-gap-2"
      @submit.native.prevent="submitForm"
    >
      <el-form-item
        :label="$t('foreigners.permits.new_permit_dialog.permit_type_name')"
        prop="permit_type_id"
      >
        <el-select
          v-model="form.permit_type_id"
          placeholder=""
          filterable
          :filter-method="permitsFilterMethod"
          :visible-change="handlePermitsVisibleChange"
        >
          <el-option
            v-for="item in filteredPermits"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-switch
          v-model="form.is_main"
          :active-text="$t('foreigners.permits.new_permit_dialog.main_permit')"
          class="tw-my-2"
        />
      </el-form-item>
    </el-form>

    <template #footer>
      <div class="tw-flex tw-justify-end tw-gap-2 flex-col md:flex-row">
        <i-button
          class="tw-w-40"
          @click="$emit('close')"
        >
          {{ $t('common.actions.cancel') }}
        </i-button>
        <i-button
          type="primary"
          class="tw-w-40"
          :is-loading="isLoading"
          @click="submitForm"
        >
          {{ $t('common.actions.save') }}
        </i-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { permitsFilterMixin } from '@/mixins/permitsFilterMixin';
import { mapGetters, mapState } from 'vuex';

export default {
  mixins: [permitsFilterMixin],
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isLoading: false,
      form: {
        permit_type_id: '',
        is_main: false,
      },
      formRules: {
        permit_type_id: [
          { required: true, message: 'Permit type is empty', trigger: 'blur' },
        ],
      },
    };
  },

  computed: {
    ...mapState({
      foreigner: (state) => state.v2.admin.foreigners.foreigner.foreigner,
    }),
    ...mapGetters({
      permits: 'v2/admin/cms/permitManagement/permitTypes/selectPermitTypesOptions',
    }),
  },

  mounted() {
    this.$store.dispatch('v2/admin/cms/permitManagement/permitTypes/loadAllPermitTypes');
  },

  methods: {
    async submitForm() {
      const isValid = await this.$refs.Form.validate().catch(() => false);
      if (!isValid) {
        return;
      }

      try {
        await this.$store.dispatch('v2/admin/foreigners/foreigner/addPermit', {
          foreignerId: this.foreigner.id,
          payload: this.form,
        });

        await this.$store.dispatch('v2/admin/foreigners/foreigner/loadPermits', this.foreigner.id);
      } catch (error) {
        this.$message.error({
          message: this.$capitalize(this.$t('core.error.internal_server_error')),
          showClose: true,
        });
      }

      this.$emit('close');
    },
  },
};
</script>
